module.exports = __webpack_public_path__ + "img/mutiwhite.2de9329f.png";